import { soilRadarText, soilText } from "utils/soilSurface";

// The switch for the estimated soil surface and its one line of text, under a radar heatmap (useSoilSurface()).
export default function SoilSurfaceControl({ soil: s }) {
  if (!s.available) return null;
  return (
    <div className="field-soil-control">
      <label>
        <input type="checkbox" checked={s.on} onChange={(e) => s.setOn(e.target.checked)} /> Estimated soil surface
      </label>
      {s.on && (
        <p className="field-caption" role="status">
          {s.loading ? "Estimating the soil surface…" : s.error || soilText(s.soil)}
        </p>
      )}
      {s.on && !s.loading && !s.error && soilRadarText(s.soil) && <p className="field-caption">{soilRadarText(s.soil)}</p>}
    </div>
  );
}
